import { Chat } from 'views/components';
import { ContainerChat } from './styled';
import PropTypes from 'prop-types';
import React from 'react';
import { Row } from 'reactstrap';
import isEmpty from 'lodash/isEmpty';
import { useTranslation } from 'react-i18next';
import {
    ButtonFooter,
    ExpandButton,
    Modal,
    Text
} from 'mol-ui';

const ChatModal = ({
    active,
    messages,
    onToggle
}) => {

    const { t } = useTranslation();

    return (
        <Modal active={ active } borderRadius="25px" onToggle={ onToggle }>
            <Row>
                <ContainerChat md="12" sm="12" >
                    {
                        !isEmpty(messages)
                            ? <Chat onlyShow bottom="0px" messages={ messages } position="relative" />
                            : <Text
                                fontSize="15px"
                                margin="10px"
                            >
                                { t('No hay resultados para mostrar.') }
                            </Text>
                    }
                </ContainerChat>
            </Row>
            <ButtonFooter margin="20px 0px 0px 0px">
                <ExpandButton
                    caption={ t('Volver') }
                    size={ 120 }
                    onClick={ onToggle }
                />
            </ButtonFooter>
        </Modal>
    );
};

ChatModal.propTypes = {
    active: PropTypes.bool,
    messages: PropTypes.array,
    onToggle: PropTypes.func
};

export default ChatModal;
